import React, { ReactNode } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { TrialBanner } from '../ui/TrialBanner';
import { useTheme } from '@context/ThemeContext';
import { useAuth } from '@context/index';
import { ImpersonationBanner } from '@components/ui/ImpersonationBanner';

interface MainLayoutProps {
  children: ReactNode;
  userName?: string;
  userEmail?: string;
  userAvatar?: string;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  userName: propUserName,
  userEmail: propUserEmail,
  userAvatar: propUserAvatar,
}) => {
  const { themeConfig } = useTheme();
  const { user } = useAuth();

  const userName  = user?.username || user?.email || propUserName || 'User';
  const userEmail = user?.email    || propUserEmail || '';
  const userAvatar = user?.profile_image || propUserAvatar || '👤';

  return (
    <div className={`flex flex-col h-screen ${themeConfig.layout.background}`}>
      {/* Admin "logged in as" a user -- always visible so it's never unclear whose account this is */}
      <ImpersonationBanner />

      {/* Trial banner */}
      <TrialBanner />

      {/* Sticky header */}
      <Header userName={userName} userEmail={userEmail} userAvatar={userAvatar} />

      {/* Body: sidebar + content */}
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />

        {/* Scrollable main content */}
        <main
          className={`flex-1 overflow-y-auto ${themeConfig.layout.contentBackground}`}
          style={{ scrollbarColor: 'rgba(255,255,255,0.08) transparent', scrollbarWidth: 'thin' }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};
